import { getToken,axiosInstance } from "../utils/Api";

export const getCategories = async (id) =>{ 
    try { 
        const response = await axiosInstance.get(`admin/game/getgamesubjectlevels?game_subject_id=${id}`,{
          headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
    } 
}
export const getgames = async (id) =>{ 
    try { 
        const response = await axiosInstance.get(`admin/game/getGamesBasedOnLevel?all=true&game_level_id=${id}`,{
          headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
    } 
}
export const deleteReview = async (id) =>{   
    try { 
        const response = await axiosInstance.delete(`admin/deleteReview`,{
          data:{review_id:id},
            headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
      } 
}
 
export const gameCreate = async (formdata) =>{ 
  try {
      const response = await axiosInstance.post("admin/game/createGame",formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 

export const gameDelete = async (formdata) =>{ 
  try {
      const response = await axiosInstance.put("admin/game/gameActiveOrDeactivate",formdata,{
          headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}  

export const getGameDetails = async (id) =>{ 
  try { 
      const response = await axiosInstance.get(`admin/game/getGameDetails?id=${id}`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
  } 
}

export const getGrades = async (id) =>{ 
  try { 
      const response = await axiosInstance.get(`admin/game/grade`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
  } 
}


export const updateGameDetail = async (data) =>{ 
  try {
      const response = await axiosInstance.put("admin/game/gameDetailsUpdate",data,{
          headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}  

export const gameFileUpdate = async (formdata) =>{ 
  try {
      const response = await axiosInstance.post("admin/game/updateGame",formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 

export const gameThumbnailUpdate = async (formdata) =>{ 
  try {
      const response = await axiosInstance.post("admin/game/thumbnailUpdate",formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 


export const updateGameStatus = async (data) =>{ 
  try {
      const response = await axiosInstance.put("admin/game/statusUpdate",data,{
          headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}